<template>
  <div class="main">
    <div class="title-bar">
      <div class="row">
        <div class="col-12 col-md-6 mb-4 text-center text-md-left">
          <h1 class="mb-0">Online Enrollment Cart</h1>
        </div>
        <div class="col-12 col-md-6 mb-3 text-center text-md-right">
          <a class="btn btn-success mr-2" :href="route('enroll.online.review')"
            >Checkout</a
          >
          <a class="btn btn-info" :href="route('catalog.online')"
            >Back to Catalog</a
          >
        </div>
      </div>
    </div>
    <div class="enrollment-cart content py-4 px-xl-2">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <transition name="fade">
              <Alert v-if="hasAlert" :alert="alert" />
            </transition>
          </div>
          <div class="col-12 col-lg-8">
            <div v-if="items.length > 0">
              <CartItem
                v-for="(item, i) in items"
                :key="i"
                :item="item"
                :index="i"
                @change-brand="changeBrand"
                @edit-nate="editNate"
                @remove="removeItem"
              />
            </div>
            <div v-else class="alert alert-info">
              <span>
                Your cart is currently empty. Check out our
                <a :href="route('catalog.online')" class="text-dark">
                  <u>Course Catalog</u>
                </a>
                for the latest course offerings.
              </span>
            </div>
          </div>
          <div v-if="items.length > 0" class="col-12 col-lg-4">
            <div class="sticky-top panel p-4 text-center">
              <h4>Cart Summary</h4>
              <h2 class="text-primary font-weight-bold mb-3">
                * Total: {{ subtotal | cost }}
              </h2>
              <p class="font-size-sm">
                * The total amount that will be charged to your credit card
              </p>
              <div class="mb-2">
                <a
                  class="btn btn-success btn-arrow-right w-100 w-sm-auto"
                  :href="route('enroll.online.review')"
                >
                  <span class="text">Proceed to Checkout</span>
                  <icon icon="arrow-right" class="svg-icon" />
                </a>
              </div>
              <div class="mb-4">
                <a class="btn-back" :href="route('catalog.online')">
                  <span class="icon icon-arrow-left"></span>
                  <span class="text">Back to Catalog</span>
                </a>
              </div>
              <p class="font-size-sm">
                <span>
                  Before completing your purchase, please review the expiration
                  time period displayed on the details page of each of the
                  courses and/or learning paths in your cart. In addition,
                  please review our
                  <a
                    :href="route('enroll.online.purchase-policy')"
                    target="_blank"
                    >Online Training Purchase Policy</a
                  >.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import CartItem from "../partials/CartItem";
import EditEnrollmentBrand from "../partials/EditEnrollmentBrand";
import EditNateCredit from "../partials/EditNateCredit";

export default {
  mixins: [DisplaysAlerts],
  components: { CartItem },
  props: {
    queue: { type: Object, required: true },
    removed: { type: Array, default: () => [] },
  },
  data() {
    return {
      items: [],
      subtotal: 0.0,
    };
  },
  methods: {
    refresh() {
      this.axios(this.route("enroll.online.cart.refresh")).then((response) => {
        this.items = response.data.items;
        this.subtotal = response.data.subtotal;
      });
    },
    removeItem(item) {
      let me = this;
      this.axios
        .delete(
          this.route("enroll.online.cart.remove", {
            type: item.item_type.replace("_", "-"),
            enrollment: item.id,
          })
        )
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your cart has been updated", true);
        });
    },
    changeBrand(item) {
      let me = this;
      this.$modal(EditEnrollmentBrand, { enrollment: item })
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your cart has been updated", true);
        })
        .catch(() => {});
    },
    editNate(item) {
      let me = this;
      this.$modal(EditNateCredit, { enrollment: item })
        .then(() => {
          me.refresh();
          me.showAlert("success", "Your cart has been updated", true);
        })
        .catch(() => {});
    },
  },
  created() {
    this.items = this.queue.items;
    this.subtotal = this.queue.subtotal;
  },
};
</script>